module.exports = __webpack_public_path__ + "static/media/shuzhihua5.80e3e949.png";